import 'firebase/firestore';
export default class FirestoreDocumentListener {
    constructor(docRef, action, conversion) {
        this.docRef = docRef;
        this.action = action;
        this.conversion = conversion;
        this.unSubscribe = null;
    }
    activate() {
        if (this.unSubscribe !== null) {
            return;
        }
        this.unSubscribe = this.docRef.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                let data = this.conversion(docSnapshot.data(), docSnapshot.id);
                this.action(data);
            }
        }, (error) => {
            console.log(`Encountered snapshot error: ${error}`);
        });
    }
    deactivate() {
        this.unSubscribe();
        this.unSubscribe = null;
    }
}
//# sourceMappingURL=FirestoreDocumentListener.js.map